import React from 'react';

const BuildingContext = React.createContext();


export default BuildingContext;